/**
 * Fetch Wallet Transactions UseCase
 * Flutter source: wallet_screen.dart - _getTransactions
 *
 * Fetches paginated wallet transactions.
 */
import { WalletService } from '@/domain/services/wallet/walletService';
import type { AppTransactionEntity } from '@/domain/entities/transaction/appTransactionEntity';
import type { PageCursor } from '@/data/types/json';
import { SERVER_FETCH_CONSTANTS } from '@/domain/constants/serverFetchConstants';

export class FetchWalletTransactionsUseCase {
  private walletService: WalletService;

  constructor(walletService: WalletService = WalletService.getInstance()) {
    this.walletService = walletService;
  }

  async execute(
    cursor?: PageCursor,
    limit?: number,
  ): Promise<{ transactions: AppTransactionEntity[]; hasMore: boolean; cursor?: PageCursor }> {
    return this.walletService.fetchTransactions(
      limit ?? SERVER_FETCH_CONSTANTS.DEFAULT_LIMIT,
      cursor,
    );
  }
}
